import { ListItem, ListItemProps, TokenIcon } from '@/components';
import { UnderlyingYieldBearingAssetInterface } from '@/interfaces';
import { FC } from 'react';
export interface UnderlyingYieldBearingAssetListItemProps
  extends Omit<ListItemProps, 'mainText' | 'subText'> {
  underlyingYieldBearingAsset: UnderlyingYieldBearingAssetInterface;
  subText?: string;
}
const UnderlyingYieldBearingAssetListItem: FC<
  UnderlyingYieldBearingAssetListItemProps
> = ({
  underlyingYieldBearingAsset,
  subText,
  isHeader = false,
  leftIcon,
  leftIconUrl,
  leftIconWidth,
  leftIconHeight,
  ...rest
}) => {
  const iconWidth = leftIconWidth ?? (isHeader ? 40 : 36);
  const iconHeight = leftIconHeight ?? (isHeader ? 40 : 36);
  const renderLeftIcon = () => {
    return leftIcon ? (
      leftIcon
    ) : (
      <TokenIcon
        key={`${underlyingYieldBearingAsset.symbol}-${Math.random()}`}
        token={underlyingYieldBearingAsset}
        tokenSymbol={underlyingYieldBearingAsset.symbol}
        alt={underlyingYieldBearingAsset.name}
        width={iconWidth}
        height={iconHeight}
      />
    );
  };
  return (
    <ListItem
      isHeader={isHeader}
      mainText={underlyingYieldBearingAsset.name}
      subText={subText ?? `${underlyingYieldBearingAsset.symbol}`}
      leftIcon={renderLeftIcon()}
      leftIconWidth={iconWidth}
      leftIconHeight={iconHeight}
      leftIconUrl={leftIconUrl}
      {...rest}
    />
  );
};
export default UnderlyingYieldBearingAssetListItem;
